<template>
  <div>
    <sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      @refetch-data="refetchData"
      :unit-options="unitOptions"
      :tag-options="tagOptions"
    />

    <b-row class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters
          :victronenergy-master-account-options="
            victronenergyMasterAccountOptions
          "
          :victronenergy-master-account-filter.sync="
            victronenergyMasterAccountFilter
          "
          update-sites-data="updateSites"
          :unit-filter.sync="unitFilter"
          :unit-options="unitOptions"
          :tag-filter.sync="tagFilter"
          :tag-options="tagOptions"
        />
      </template>
      <template v-slot:footer-buttons>
        <b-button
          variant="secondary"
          class="float-right text-capitalize"
          size="sm"
          @click="updateSites()"
          >{{ $t("actions.sync") + " " + $t("victronenergy.sites.title") }}
        </b-button>
      </template>
    </filter-modal>

    <toastification-loading-content ref="loadingToast" />

    <b-card-group deck class="mx-2 mt-1">
      <b-card class="m-0" no-body>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                data-cy="per-page-selector"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search')"
                  data-cy="search-input"
                />
                <b-button
                  @click="exportExcel()"
                  variant="success"
                  class="text-capitalize ml-1"
                  type="button"
                  :disabled="buttonExport"
                  v-b-tooltip.hover
                  :title="`${$t('messages.export.title')}`"
                >
                  <feather-icon icon="DownloadCloudIcon" size="15" />
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
          @row-selected="onRowSelected"
          select-mode="single"
          selectable
        >
          <template #head()="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #head(actions)="data">
            <span> {{ $tc(data.label, 2) }}</span>
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-list-group-item
                @click="openEdit(data.item)"
                v-if="$can('update', 'Victronenergy')"
                class="border-0"
                button
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50 text-capitalize">
                  {{ $t("actions.edit") }}
                </span>
              </b-list-group-item>

              <b-dropdown-item @click="viewDevices(data.item)">
                <feather-icon icon="MonitorIcon" />
                <span class="align-middle ml-50 text-capitalize">{{
                  $t("actions.show")+' '+$t("victronenergy.sites.devices")
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <Pagination
                :totalList="totalList"
                :currentPage="currentPage"
                @updatePagination="update"
                :perPage="perPage"
                data-cy="pagination"
              >
              </Pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card class="m-2 sticky-card pb-2" v-if="selectedObject" no-body>
        <div class="ml-auto float-rigth">
          <feather-icon
            icon="XIcon"
            class="mr-2 ml-auto float-rigth"
            style="cursor: pointer"
            size="30"
            @click="selectedObject = null"
          />
        </div>
        <div class="mx-2">
          <div>
            <b-card class="mb-0">
              <template>
                <div class="chart-container">
                  <div 
                    v-if="loadingChart"
                    class="loader-chart"
                  >
                    <b-spinner variant="primary"></b-spinner>
                    <div>
                      {{$t("actions.loading")}}
                    </div>
                  </div>

                  <div v-else-if="!hasChartData" class="loader-chart">
                    {{$t('no_record_found')}}
                  </div>

                  <canvas
                    v-show="!loadingChart && hasChartData"
                    id="victronChart"
                    class="frame"
                  ></canvas>

                </div>
              </template>
            </b-card>
          </div>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onBeforeUnmount, onMounted } from "@vue/composition-api";
import useList from "./useList";
import Sidenav from "./Sidenav.vue";
import Filters from "./Filters.vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import router from '@/router';
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import Pagination from "@/components/Pagination.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import axios from "@axios";
import Chart from "chart.js/auto";

export default {
  components: {
    Sidenav,
    Filters,
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ToastificationLoadingContent,
    Pagination,
    FilterModal,
    ButtonFilters,
    Chart,
  },

  setup(_, context) {

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      victronenergyMasterAccountOptions,
      victronenergyMasterAccountFilter,
      clearSearchFilters,
      filtersCount,
      buildFilters,
      unitOptions,
      unitFilter,
      tagOptions,
      tagFilter
    } = useList();

    const update = (data) => {
      currentPage.value = data;
    };

    const { t } = useI18nUtils();
    const toast = useToast();
    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const buttonExport = ref(false);
    const loadingToast = ref(null);
    const action = ref("list");
    const selectedObject = ref(null);

    const exportExcel = () => {
      action.value == "export";
      buttonExport.value = true;
      loadingToast.value.show(
        context.parent.$i18n.t("messages.export.download"),
        context.parent.$i18n.t("messages.export.Generating_file"),
        "secondary"
      );
      store
        .dispatch("victronenergy_sites/export", {
          q: searchQuery.value,
          max: perPage.value,
          "page[n]": currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          action: "export",
        })
        .then((response) => {
          console.log(response);
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: context.parent.$i18n.t("messages.error.server_error"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loadingToast.value.close();
          buttonExport.value = false;
        });
    };

    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = item;
      isAdd.value = false;
    };

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("victronenergy_sites/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const updateSites = () => {
      if (
        victronenergyMasterAccountFilter.value == null ||
        victronenergyMasterAccountFilter.value.length == 0
      ) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Seleccionar master account",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } else {
        loadingToast.value.show(
          context.parent.$i18n.t("actions.sync"),
          context.parent.$i18n.t("actions.synchronizing"),
          "secondary"
        );
        store
          .dispatch("victronenergy_sites/updateSites", {
            victronenergy_master_account:
              victronenergyMasterAccountFilter.value,
          })
          .then((response) => {
            console.log(response);
            if (response.success) {
              loadingToast.value.close();
              toast({
                component: ToastificationContent,
                props: {
                  title: response.message,
                  icon: "CheckIcon",
                  variant: "success",
                },
              });
              refetchData();
            } else {
              loadingToast.value.close();
              toast({
                component: ToastificationContent,
                props: {
                  title: response.message,
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            }
          })
          .catch((response) => {
            console.log(response)
            loadingToast.value.close();
            toast({
              component: ToastificationContent,
              props: {
                title: response.response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    };

    const onRowSelected = (item) => {
      if (item[0]) {
        selectedObject.value = item[0];
        stats(selectedObject.value.id);
      }
    };

    let chartInstance = null
    const loadingChart = ref(false);
    const hasChartData = ref(false);
    const stats = async (id) => {

      try {
        loadingChart.value = true;
        hasChartData.value = false;
        const { data } = await axios.get(`/v1/victronenergy/sites/${id}/stats`);

        const records = data.records;
        const hasData = records && ((records.Pdc && records.Pdc.length > 0) || (records.bs && records.bs.length > 0) || (records.bv && records.bv.length > 0));
        console.log
        if (!hasData) {
          return;
        }

        hasChartData.value = true;
        const ctx = document.getElementById("victronChart");
        if (!ctx) return;

        if (chartInstance) {
          chartInstance.destroy();
        }

        chartInstance = new Chart(ctx, {
          type: "line",
          data: {
            datasets: [
              {
                label: "Pdc",
                borderColor: "#ff9800",
                backgroundColor: "transparent",
                borderWidth: 2,
                tension: 0.4,
                data: data.records.Pdc.map(item => ({
                  x: new Date(item[0]).toLocaleTimeString(),
                  y: item[1]
                }))
              },

              {
                label: "Battery SOC",
                borderColor: "#2196f3",
                backgroundColor: "transparent",
                borderWidth: 2,
                tension: 0.4,
                data: data.records.bs.map(item => ({
                  x: new Date(item[0]).toLocaleTimeString(),
                  y: item[1]
                }))
              },

              {
                label: "Battery Voltage",
                borderColor: "#4caf50",
                backgroundColor: "transparent",
                borderWidth: 2,
                tension: 0.4,
                data: data.records.bv.map(item => ({
                  x: new Date(item[0]).toLocaleTimeString(),
                  y: item[1]
                }))
              }
            ]
          },

          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                type: "category",
                ticks: {
                  maxTicksLimit: 10
                }
              },
              y: {
                beginAtZero: true
              }
            },
            plugins: {
              legend: {
                position: "top"
              }
            }
          }
        });

      } catch (error) {
        console.error("Error cargando stats", error);

      } finally {
        loadingChart.value = false;

      }
    }

    onBeforeUnmount(() => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    });

    const viewDevices = function (data) {
      const id = data?.id;
      if (!id) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'No existe el sitio',
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      router.push({
        name: "victronenergy_devices",
        params: {
          id_site: id
        }
      });

      //router.push({ path: '/victronenergy/sites/:id_site/devices'+ id });
    };

    return {
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      buttonExport,
      loadingToast,
      action,
      exportExcel,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      update,
      filtersCount,
      buildFilters,
      clearSearchFilters,
      victronenergyMasterAccountOptions,
      victronenergyMasterAccountFilter,
      updateSites,
      viewDevices,
      onRowSelected,
      selectedObject,
      loadingChart,
      hasChartData,
      unitOptions,
      unitFilter,
      tagOptions,
      tagFilter,
    };
  },
};
</script>
<style>
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}

.chart-container canvas {
  width: 100% !important;
  height: 400px !important;
}

.loader-chart {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>